<template>
  <div class="container-fluid">
    <div>
      <div class="collapsed d-flex mt-2" data-toggle="collapse" data-target="#descriptionContent" aria-expanded="true" role="button">
        <h5 class="p-2">Description</h5>
        <span class="ml-md-auto p-2">
          <font-awesome-icon class="fa-lg" icon="chevron-down"/>
        </span>
      </div>
      <hr />
      <p class="collapse p-2" id="descriptionContent">
        A baseball game happening in town.
        <br />You are the gatekeeper standing in front of a line of people wearing baseball caps.
        <br />Your job is to take care that every person has its cap pointing in the same direction.
        <br />
      </p>
    </div>
    <div>
      <div data-toggle="collapse" data-target="#controlContent" class="collapsed d-flex" aria-expanded="true" role="button">
        <h5 class="p-2">Controls</h5>
        <span class="ml-md-auto p-2">
          <font-awesome-icon class="fa-lg" icon="chevron-down"/>
        </span>
      </div>
      <div class="collapse p-2" id="controlContent">
        <hr />
        <p class="p-2">
          <span v-if="isTouchDevice"> Touch a cap to change it's orientation.</span>
          <span v-if="!isTouchDevice"> Click on a cap to change its orientation.</span>
          <br />
          <span v-if="isTouchDevice">
            Tap ( longer touch ) to mark a cap. Afterwards tap another cap
            to change every cap's orientation inbetween those.
          </span>
          <span v-if="!isTouchDevice">
            Double click on a cap to mark it. Afterwards double click another one
            to change every cap's orientation inbetween those.
          </span>
          <br/>
          <span>
            Your goal is to use as few instructions as possible: <b>{{ nLeastMovesPossible }}</b>
          </span>
        </p>
      </div>
      <hr />
      <div class="d-flex">
        <div class="p-2">
          <font-awesome-icon title="Instruction counter" class="fa-2x cursor-help" icon="bullhorn"/>
            <span title="Swap caps to increase the counter" id="statsCounter" class="align-top badge badge-pill badge-dark ml-2 p-2 cursor-help">{{ nCommands }}/{{ nLeastMovesPossible }}</span>
        </div>
        <div class="card-title p-2 ml-md-auto">
          <button type="button" class="btn btn-dark" @click="reset(nCapsDefault)">Reset</button>
        </div>
      </div>
      <hr />
      <div @mouseleave="resetShakes()">
        <Cap
          @click.native="onClickCap(idx)"
          @dblclick.native="onDblClickCap(idx)"
          @mouseover.native="onHoverCap(idx)"
          @touchstart.native="touchCapStart(idx, $event)"
          @touchmove.native="touchCapMove(idx, $event)"
          @touchend.native="touchCapEnd(idx, $event)"
          v-for="(item, idx) in peopleInLine"
          v-bind:key="idx"
          :orientation="item.orientation"
          :marked="item.marked"
          :shaking="item.shaking"
        />
      </div>
    </div>
  </div>
</template>

<script>

import Cap from "@/components/Cap.vue";
import isTouchDevice from "@/config.js";

const MAX_PEOPLE_IN_LINE = 30;
const DEFAULT_N_CAPS = 20;

function generateLineOfPeople(nPeople) {
  if (nPeople <= 2 || nPeople > MAX_PEOPLE_IN_LINE) {
    throw new Error(
      `InvalidArgumentException: nPeople has to be inbetween ${2} and ${MAX_PEOPLE_IN_LINE}`
    );
  }
  let nBackwards = 0;
  let nForwards = 0;
  const t = Array.from(new Array(nPeople)).map(() => {
    const d = Math.random() < 0.5 ? -1 : 1;
    if (d === -1) {
      nBackwards += 1;
    } else {
      nForwards += 1;
    }
    return {
      orientation: d,
      marked: false,
      shaking: false
    };
  });
  if (nBackwards === 0 || nForwards === 0) {
    t[Math.ceil(Math.random() * t.length)].orientation *= -1;
  }
  return t;
}

function calcIntervals(ppl){
  // If the sum is 
  let nInstructionsRequired = 0
  let intervals = []
  let start = 0, nInstructionsTurnLeft = 0, nInstructionsTurnRight = 0
  ppl = ppl.concat(["END"])
  for(let i = 1; i < ppl.length; i++){
    if(ppl[start].orientation !== ppl[i].orientation){
      intervals.push([start, i-1, ppl[start].orientation])
      start = i
      if(ppl[start].orientation === -1){
        nInstructionsTurnRight++ 
      }else{
        nInstructionsTurnLeft++
      }
    }
  }
  nInstructionsRequired = nInstructionsTurnLeft > nInstructionsTurnRight ? nInstructionsTurnRight : nInstructionsTurnLeft
  return nInstructionsRequired
}

export default {
  name: "YouWillConfirm",
  components: {
    Cap
  },
  data() {
    const ppl = generateLineOfPeople(DEFAULT_N_CAPS)
    return {
      idxMarkedCap: -1,
      isTouchDevice: isTouchDevice,
      nCapsDefault: DEFAULT_N_CAPS,
      nClicks: 0,
      nCommands: 0,
      nLeastMovesPossible: calcIntervals(ppl),
      peopleInLine: ppl,
      tmTouchStart: 0
    };
  },
  methods: {
    _swapCap(idx) {
      this.peopleInLine[idx].orientation *= -1;
      // this.$set(this.peopleInLine, idx, -1 * this.peopleInLine[idx]);
    },
    _markCap(idx, marked) {
      this.peopleInLine[idx].marked = marked;
    },
    _shakeCap(idx, shake) {
      this.peopleInLine[idx].shaking = shake;
    },
    _getCapIndexFromPoint(point) {
      let el = document.elementFromPoint(point.clientX, point.clientY);
      while (el) {
        if (el.__vue__) {
          break;
        }
        el = el.parentElement;
      }
      const cmp = this.$children.find(c => c.$el === el);
      return cmp ? cmp.$vnode.key : undefined;
    },
    resetShakes() {
      for (let i = 0; i < this.peopleInLine.length; i++) {
        this._shakeCap(i, false);
      }
    },
    reset(nCaps) {
      nCaps = nCaps || 10;
      this.nClicks = 0;
      this.nCommands = 0;
      this.idxMarkedCap = -1;
      this.peopleInLine = generateLineOfPeople(nCaps);
      this.nLeastMovesPossible = calcIntervals(this.peopleInLine)
    },
    touchCapEnd(idx, $event) {
      $event.preventDefault();
      const tmDeltaTouch = Date.now() - this.tmTouchStart;
      const p = $event.changedTouches[$event.changedTouches.length - 1];
      idx = this._getCapIndexFromPoint(p) || idx;
      if (tmDeltaTouch < 200) {
        this.onClickCap(idx);
      } else {
        this.onDblClickCap(idx);
      }
    },
    touchCapStart(idx, $event) {
      $event.preventDefault();
      this.tmTouchStart = Date.now();
    },
    touchCapMove(idx, $event) {
      let p = $event.touches[0];
      idx = this._getCapIndexFromPoint(p);
      if (idx) {
        this.onHoverCap(idx);
      }
    },
    onClickCap(idx) {
      this.nClicks++;
      setTimeout(() => {
        if (this.nClicks === 1) {
          this.nCommands++;
          this._swapCap(idx);
        }
        this.nClicks = 0;
      }, 200);
    },
    onDblClickCap(idx) {
      if (this.idxMarkedCap === -1) {
        this.idxMarkedCap = idx;
        this._markCap(idx, true);
      } else {
        const idxCapOld = this.idxMarkedCap;
        if (this.idxMarkedCap === idx || this.idxMarkedCap > idx) {
          this.idxMarkedCap = -1;
        } else {
          this.nCommands++;
          for (let i = this.idxMarkedCap; i <= idx; i++) {
            this._swapCap(i);
            this._shakeCap(i, false);
          }
          this.idxMarkedCap = -1;
        }
        this._markCap(idxCapOld, false);
      }
    },
    onHoverCap(idx) {
      if (this.idxMarkedCap === -1) {
        return;
      }
      if (this.idxMarkedCap >= idx) {
        for (let i = this.idxMarkedCap; i < this.peopleInLine.length; i++) {
          this._shakeCap(i, false);
        }
        return;
      }
      let i = this.idxMarkedCap;
      for (; i <= idx; i++) {
        this._shakeCap(i, true);
      }
      for (; i < this.peopleInLine.length; i++) {
        this._shakeCap(i, false);
      }
    }
  },
  created() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .cursor-help { cursor: help; }
  div[data-toggle="collapse"] > span{
   -webkit-transition: all 0.2s ease-out;
   -moz-transition: all 0.2s ease-out;
   -ms-transition: all 0.2s ease-out;
   -o-transition: all 0.2s ease-out;
   transition: all 0.2s ease-out;
  }
  div[data-toggle="collapse"].collapsed > span{
    transform: rotate(-90deg);
  }
  div[data-toggle="collapse"]:hover{
    background-color: #F8F9FA;
  }
</style>
